import { render, staticRenderFns } from "./Caja.vue?vue&type=template&id=bfa6e820&scoped=true"
import script from "./Caja.vue?vue&type=script&lang=js"
export * from "./Caja.vue?vue&type=script&lang=js"
import style0 from "./Caja.vue?vue&type=style&index=0&id=bfa6e820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa6e820",
  null
  
)

export default component.exports